/**
 * --- External Imports ---
 */
import { Field, Input } from "@ngt/forms-core";
import { FC } from "react";

/**
 * --- Internal Imports ---
 */
import { DropdownWithNumberFormField } from "../../../../api/dtos/dtos";
import InputDropdownWithNumberField from "../InputDropdownWithNumberField";
import TextFieldControlLabel from "../labels/TextFieldControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";
import { Box } from "@mui/material";


/**
 * --- Dropdown Component ---
 */
const FormFieldDropdown: FC<IFormFieldComponentProps<DropdownWithNumberFormField>> = ({
    field,
    form
}) => {
    return (
        <TextFieldControlLabel 
            field={field}
            control={
                <Box
                    sx={{
                        width: '100%'
                    }}
                >
                    <Field propertyPath={`${form.name}.${field.name}`}>
                        <Input 
                            fullWidth
                            size="small"
                            component={InputDropdownWithNumberField}
                            nullOption={field.nullOption ?? true}
                            minValue={field.minValue}
                            minLabel={field.minLabel}
                            maxValue={field.maxValue}
                            maxLabel={field.maxLabel}
                            step={field.step}
                            defaultValue={field.default}
                        />
                        <FieldErrors />
                    </Field>

                </Box>
            }
        />
    );
}

export default FormFieldDropdown;